import { createSlice } from '@reduxjs/toolkit';
import { displayInitialState } from './display.defaults';

export const collectorsDisplaySlice = createSlice({
  name: 'display',
  initialState: displayInitialState,
  reducers: {
    OPEN_FILTERS_Collectors: (state) => {
      state.isFiltersDialogOpen = true;
    },
    CLOSE_FILTERS_Collectors: (state) => {
      state.isFiltersDialogOpen = false;
    },
  },
});
